import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";

// Initialize Firebase
const firebaseConfig = {
    apiKey: "AIzaSyCtNzETT3mxadV4CWMEKwD9tsyTQcql4ks",
    authDomain: "mookambika-dev.firebaseapp.com",
    projectId: "mookambika-dev",
    storageBucket: "mookambika-dev.appspot.com",
    messagingSenderId: "968842429585",
    appId: "1:968842429585:web:08e74c34a93c7b37b72b30",
    measurementId: "G-QW30N7GL6L"
  };
  const app = initializeApp(firebaseConfig);
// Firebase storage reference
const storage = getStorage(app);
export default storage;